import {RbacRecordPermissions} from '../types/typeRoleBasedAccessControls';

export const rbacDepartments = {
  SUPER_ADMIN: 'superadmin',
  IT_SUPERVISOR: 'itsupervisor',
  IT_USER: 'ituser',
  ISLANDER_MANAGER: 'islandermanager',
  ISLANDER_SUPERVISOR: 'islandersupervisor',
  ISLANDER_USER: 'islanderuser',
  GIE_MANAGER: 'giemanager',
  GIE_SUPERVISOR: 'giesupervisor',
  GIE_USER: 'gieuser',
  FINANCE_USER: 'financeuser',
  CPD_USER: 'cpduser',
  AGENCY_MANAGER: 'agencymanager',
  AGENCY_SUPERVISOR: 'agencysupervisor',
  AGENCY_USER: 'agencyuser',
} as const;

export const rbacPermissions: RbacRecordPermissions = {
  // Islander Members - Listing Permissions
  ISLANDER_MEMBERS__LISTING__VIEW: 'islander_members:listing:view',
  ISLANDER_MEMBERS__LISTING__EDIT: 'islander_members:listing:edit',
  ISLANDER_MEMBERS__LISTING__DELETE: 'islander_members:listing:delete',
  ISLANDER_MEMBERS__LISTING__EXPORT: 'islander_members:listing:export',

  // Islander Members - Terminated Members Permissions
  ISLANDER_MEMBERS__TERMINATED_MEMBERS__VIEW:
    'islander_members:terminated_members:view',

  // Islander Members - Watchlist Tags Permissions
  ISLANDER_MEMBERS__WATCHLIST_TAGS__VIEW:
    'islander_members:watchlist_tags:view',
  ISLANDER_MEMBERS__WATCHLIST_TAGS__CREATE:
    'islander_members:watchlist_tags:create',
  ISLANDER_MEMBERS__WATCHLIST_TAGS__EDIT:
    'islander_members:watchlist_tags:edit',
  ISLANDER_MEMBERS__WATCHLIST_TAGS__DELETE:
    'islander_members:watchlist_tags:delete',

  // Island Partners Permissions
  ISLAND_PARTNERS__LISTING__VIEW: 'island_partners:listing:view',
  ISLAND_PARTNERS__LISTING__CREATE: 'island_partners:listing:create',
  ISLAND_PARTNERS__LISTING__EDIT: 'island_partners:listing:edit',
  ISLAND_PARTNERS__LISTING__DELETE: 'island_partners:listing:delete',
  ISLAND_PARTNERS__LISTING__EXPORT: 'island_partners:listing:export',

  // Administrators Permissions
  ADMINISTRATORS__LISTING__VIEW: 'administrators:listing:view',
  ADMINISTRATORS__LISTING__CREATE_ADMINISTRATORS:
    'administrators:listing:create_administrators',
  ADMINISTRATORS__LISTING__CREATE_MERCHANTS:
    'administrators:listing:create_merchants',
  ADMINISTRATORS__LISTING__EDIT_ADMINISTRATORS:
    'administrators:listing:edit_administrators',
  ADMINISTRATORS__LISTING__EDIT_MERCHANTS:
    'administrators:listing:edit_merchants',
  ADMINISTRATORS__LISTING__DELETE_ADMINISTRATORS:
    'administrators:listing:delete_administrators',
  ADMINISTRATORS__LISTING__DELETE_MERCHANTS:
    'administrators:listing:delete_merchants',
  ADMINISTRATORS__LISTING__EXPORT: 'administrators:listing:export',

  // Points Transactions - Listing Permissions
  POINTS_TRANSACTIONS__LISTING__VIEW: 'points_transactions:listing:view',
  POINTS_TRANSACTIONS__LISTING__EDIT: 'points_transactions:listing:edit',
  POINTS_TRANSACTIONS__LISTING__EXPORT: 'points_transactions:listing:export',

  // Points Transactions - Receipt Validation Permissions
  POINTS_TRANSACTIONS__RECEIPT_VALIDATION__VIEW:
    'points_transactions:receipt_validation:view',
  POINTS_TRANSACTIONS__RECEIPT_VALIDATION__EXPORT:
    'points_transactions:receipt_validation:export',

  // Limited Events Permissions
  POINTS_MULTIPLIER_EVENT__LISTING__VIEW:
    'points_multiplier_event:listing:view',
  POINTS_MULTIPLIER_EVENT__LISTING__CREATE:
    'points_multiplier_event:listing:create',
  POINTS_MULTIPLIER_EVENT__LISTING__EDIT:
    'points_multiplier_event:listing:edit',
  POINTS_MULTIPLIER_EVENT__LISTING__DELETE:
    'points_multiplier_event:listing:delete',
  POINTS_MULTIPLIER_EVENT__LISTING__EXPORT:
    'points_multiplier_event:listing:export',

  // Referral Programme - Partnership Permissions
  REFERRAL_PROGRAMME__PARTNERSHIPS__VIEW: 'referral_programme:partnership:view',
  REFERRAL_PROGRAMME__PARTNERSHIPS__CREATE:
    'referral_programme:partnership:create',
  REFERRAL_PROGRAMME__PARTNERSHIPS__EDIT: 'referral_programme:partnership:edit',
  REFERRAL_PROGRAMME__PARTNERSHIPS__DELETE:
    'referral_programme:partnership:delete',
  REFERRAL_PROGRAMME__PARTNERSHIPS__EXPORT:
    'referral_programme:partnership:export',

  // Referral Programme - Islander Member Permissions
  REFERRAL_PROGRAMME__ISLANDER_MEMBERS__VIEW:
    'referral_programme:islander_member:view',
  REFERRAL_PROGRAMME__ISLANDER_MEMBERS__EDIT:
    'referral_programme:islander_member:edit',

  // Referral Programme - Referral Transactions Permissions
  REFERRAL_PROGRAMME__REFERRAL_TRANSACTIONS__VIEW:
    'referral_programme:referral_transactions:view',
  REFERRAL_PROGRAMME__REFERRAL_TRANSACTIONS__EXPORT:
    'referral_programme:referral_transactions:export',

  // Voucher Transaction Permissions
  VOUCHER_TRANSACTIONS__LISTING__VIEW: 'voucher_transaction:listing:view',
  VOUCHER_TRANSACTIONS__LISTING__EXPORT: 'voucher_transaction:listing:export',

  // Voucher - Listing Permissions
  VOUCHERS__LISTING__VIEW: 'voucher:listing:view',
  VOUCHERS__LISTING__CREATE: 'voucher:listing:create',
  VOUCHERS__LISTING__EDIT: 'voucher:listing:edit',
  VOUCHERS__LISTING__DELETE: 'voucher:listing:delete',
  VOUCHERS__LISTING__EXPORT: 'voucher:listing:export',

  // Voucher - Featured Vouchers Permissions
  VOUCHERS__FEATURED_VOUCHERS__VIEW: 'voucher:featured_vouchers:view',
  VOUCHERS__FEATURED_VOUCHERS__EDIT: 'voucher:featured_vouchers:edit',
  VOUCHERS__FEATURED_VOUCHERS__DELETE: 'voucher:featured_vouchers:delete',

  // Voucher - Targeted Distribution Permissions
  VOUCHERS__TARGETED_DISTRIBUTIONS__EXECUTE:
    'voucher:targeted_distribution:execute',

  // Voucher - Distribution Logs Permissions
  VOUCHERS__TARGETED_DISTRIBUTION_LOGS__VIEW:
    'voucher:targeted_distribution_logs:view',

  // Voucher - Voucher Categories Permissions
  VOUCHERS__VOUCHER_CATEGORIES__VIEW: 'voucher:voucher_categories:view',
  VOUCHERS__VOUCHER_CATEGORIES__CREATE: 'voucher:voucher_categories:create',
  VOUCHERS__VOUCHER_CATEGORIES__EDIT: 'voucher:voucher_categories:edit',
  VOUCHERS__VOUCHER_CATEGORIES__DELETE: 'voucher:voucher_categories:delete',
  VOUCHERS__VOUCHER_CATEGORIES__EXPORT: 'voucher:voucher_categories:export',

  // Mobile App CMS - Event Permissions
  MOBILE_APP_CMS__EVENTS__VIEW: 'mobile_app_cms:event:view',
  MOBILE_APP_CMS__EVENTS__CREATE: 'mobile_app_cms:event:create',
  MOBILE_APP_CMS__EVENTS__EDIT: 'mobile_app_cms:event:edit',
  MOBILE_APP_CMS__EVENTS__DELETE: 'mobile_app_cms:event:delete',

  // Mobile App CMS - Article Permissions
  MOBILE_APP_CMS__ARTICLES__VIEW: 'mobile_app_cms:article:view',
  MOBILE_APP_CMS__ARTICLES__EDIT: 'mobile_app_cms:article:edit',

  // Mobile App CMS - Member Dashboard Permissions
  MOBILE_APP_CMS__MEMBER_DASHBOARD__VIEW:
    'mobile_app_cms:member_dashboard:view',
  MOBILE_APP_CMS__MEMBER_DASHBOARD__CREATE:
    'mobile_app_cms:member_dashboard:create',
  MOBILE_APP_CMS__MEMBER_DASHBOARD__EDIT:
    'mobile_app_cms:member_dashboard:edit',
  MOBILE_APP_CMS__MEMBER_DASHBOARD__DELETE:
    'mobile_app_cms:member_dashboard:delete',

  // Mobile App CMS - Media Library Permissions
  MOBILE_APP_CMS__MEDIA_LIBRARY__VIEW: 'mobile_app_cms:media_library:view',
  MOBILE_APP_CMS__MEDIA_LIBRARY__CREATE: 'mobile_app_cms:media_library:create',
  MOBILE_APP_CMS__MEDIA_LIBRARY__DELETE: 'mobile_app_cms:media_library:delete',

  // Audit - Admin Permissions
  AUDIT__ADMIN_LOGS__VIEW: 'audit_admin:listing:view',
  AUDIT__ADMIN_LOGS__EXPORT: 'audit_admin:listing:export',

  // Audit - Members Permissions
  AUDIT__MEMBER_LOGS__VIEW: 'audit_members:listing:view',
};
